import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/components/blocks/core/GalleryBlock/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/NextImage/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SocialMedia/ShareButtonsArticleMobile.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/SocialMedia/SocialMediaSidebar.tsx")